/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import GrantsIcon from 'icons/GrantsIcon';

const messages = defineMessages({
  title: {id: 'navigation.transactions'},
});

const TransactionsItem = () => (
  <RouteLinkItem
    iconBefore={GrantsIcon}
    route="midas/students/grants"
    title={messages.title}
  />
);

export default TransactionsItem;
